import { SEGMENT_BUCKETS } from '../constants';
import type { Group, SubGroup } from '../types';
import { hasSegmentFee } from './hasSegmentFee';
import { isMultipartnerSegment } from './marketOperatorRestrictions';

export const containsPricedMultipartnerSegment = (
  group: Omit<Group, 'uuid'> | Omit<SubGroup, 'uuid'>,
  currentAccountId: string
): boolean => {
  if ('groups' in group) {
    return group.groups.some(subgroup => containsPricedMultipartnerSegment(subgroup, currentAccountId));
  }

  return SEGMENT_BUCKETS.some(bucket =>
    group[bucket]?.segments?.some(
      segment => isMultipartnerSegment(segment, currentAccountId) && hasSegmentFee(segment.price_pom, segment.price_cpm)
    )
  );
};
